import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withCookies } from 'react-cookie';
import { withRouter } from 'react-router';
import { authComplete, verifyToken } from './modules/Auth';
import PropTypes from 'prop-types';
import CssBaseline from '@material-ui/core/CssBaseline';
import { withStyles } from '@material-ui/core/styles';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import store from './store';
import { setGlobalLoadingSpinner } from './modules/GlobalUI';

import './App.css';
import Layout from "./layouts/Navigation";

const styles = theme => ({
  root: {
    display: 'flex',
    height: '100vh',
  },
});

toast.configure({
  autoClose: 8000,
  draggable: false,
  position: toast.POSITION.BOTTOM_LEFT,
});

toast.onChange( () => {
  store.dispatch(setGlobalLoadingSpinner());
});

class App extends Component {
  async componentDidMount() {
    const { authComplete, cookies, verifyToken } = this.props;
    const token = cookies.get('APIToken');
    if (token) {
      await verifyToken(token, cookies);
    }
    else {
      authComplete();
    }
  }

  render() {
    const { auth: { isAuthenticating }, classes } = this.props;

    return isAuthenticating ? null : (
      <div className={classes.root}>
        <CssBaseline />
        <Layout />
      </div>
    );
  }
}

App.propTypes = {
  classes: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
	return {
    auth: state.authState,
	}
}

function mapDispatchToProps(dispatch){
	return bindActionCreators({
    authComplete: authComplete,
    setGlobalLoadingSpinner: setGlobalLoadingSpinner,
    verifyToken: verifyToken,
	}, dispatch)
}

export default compose(withRouter, withCookies, connect(mapStateToProps, mapDispatchToProps), withStyles(styles))(App);
